import React from 'react';
import styles from './FilterPanel.module.css';

const FilterPanel = ({
  selectedStatuses,
  selectedCategories,
  selectedModes,
  categories,
  onStatusChange,
  onCategoryChange,
  onModeChange,
  onClearAll,
  onClose
}) => {
  const selectedCount = selectedStatuses.length + selectedCategories.length + selectedModes.length;
  
  return (
    <div className={styles.filterPanel}>
      <div className={styles.filterHeader}>
        <div className={styles.filterTitle}>Filters</div>
        {selectedCount > 0 && (
          <div className={styles.filterCountBadge}>
            <span className={styles.filterCountText}>{selectedCount}</span>
            <button 
              className={styles.clearAllButton}
              onClick={onClearAll}
              aria-label="Clear all filters"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 4.1125L9.8875 3.5L7 6.3875L4.1125 3.5L3.5 4.1125L6.3875 7L3.5 9.8875L4.1125 10.5L7 7.6125L9.8875 10.5L10.5 9.8875L7.6125 7L10.5 4.1125Z" fill="#505050"/>
              </svg>
            </button>
          </div>
        )}
      </div>
      <div className={styles.filterSection}>
        <div className={styles.filterSectionTitle}>Status</div>
        <div className={styles.filterOptions}>
          <div className={styles.filterOption}>
            <input
              type="checkbox"
              id="drafts"
              checked={selectedStatuses.includes('draft')}
              onChange={(e) => onStatusChange('draft', e.target.checked)}
              className={styles.filterCheckbox}
            />
            <label htmlFor="drafts" className={styles.filterLabel}>Drafts</label>
          </div>
          <div className={styles.filterOption}>
            <input
              type="checkbox"
              id="completed"
              checked={selectedStatuses.includes('completed')}
              onChange={(e) => onStatusChange('completed', e.target.checked)}
              className={styles.filterCheckbox}
            />
            <label htmlFor="completed" className={styles.filterLabel}>Completed</label>
          </div>
        </div>
      </div>

      <div className={styles.filterDivider}></div>

      <div className={styles.filterSection}>
        <div className={styles.filterSectionTitle}>Mode</div>
        <div className={styles.filterOptions}>
          <div className={styles.filterOption}>
            <input
              type="checkbox"
              id="mode-new"
              checked={selectedModes.includes('new')}
              onChange={(e) => onModeChange('new', e.target.checked)}
              className={styles.filterCheckbox}
            />
            <label htmlFor="mode-new" className={styles.filterLabel}>New Listing</label>
          </div>
          <div className={styles.filterOption}>
            <input
              type="checkbox"
              id="mode-existing"
              checked={selectedModes.includes('existing')}
              onChange={(e) => onModeChange('existing', e.target.checked)}
              className={styles.filterCheckbox}
            />
            <label htmlFor="mode-existing" className={styles.filterLabel}>Existing Listing</label>
          </div>
        </div>
      </div>

      <div className={styles.filterDivider}></div>

      <div className={styles.filterSection}>
        <div className={styles.filterSectionTitle}>Categories</div>
        <div className={styles.filterOptions}>
          {categories.map(category => (
            <div key={category} className={styles.filterOption}>
              <input
                type="checkbox"
                id={`category-${category}`}
                checked={selectedCategories.includes(category)}
                onChange={(e) => onCategoryChange(category, e.target.checked)}
                className={styles.filterCheckbox}
              />
              <label htmlFor={`category-${category}`} className={styles.filterLabel}>{category}</label>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.filterActions}>
        <button className={styles.clearFiltersButton} onClick={onClearAll}>
          Clear All
        </button>
        <button className={styles.applyFiltersButton} onClick={onClose}>
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
